import {
  Accordion,
  Card,
  Col,
  ImageWithFallback,
  Label,
  Row,
  Tooltip,
} from "../../../../CommonComponents";
import "./DriverDetail.scss";
import RequestReasonDetail from "client/Components/OrderManagement/ApprovalOrder/LeadrOrder/ItemDetail/RequestReasonDetail";
import AttachmentLink from "../../ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink";
import placeholder from "../.././../../assets/images/Placeholder.svg";
import { CONSTANTS } from "client/utils/constants";
import Moment from 'moment';
import NonStandardItemDetail from "client/CommonComponents/NonStandardItemDetail";

const DriverDetail = (props: any) => {

  let actionCommentValue: any[] = [];
  let userActionComment: any[] = [];

  const ExpandedItems: any[] = [];
  
  props?.orderDetails?.requests?.map((item: any, index: any) => {
      const itemIdVal = () => {
          if (item?.orderId != null) {
              return item?.orderId + " - " + (index + 1);
          } else {
              return "-";
          }
      };
    const getEquipmentType = () => {
      if (item?.subOrderType) {
        return item?.subOrderType
      } else {
        return "-"
      }
    }

  return ExpandedItems.push({
    headerText: (
      <>
        <div
          id="myLI"
          className={`${
            item?.orderType === CONSTANTS.MANAGED_EQUIPMENT
              ? "managed-equipment"
              : ""
          } LeaderOrderHeader driverDetail`}
        >
          {item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ? (
            <div className="leadrTitle">
              {item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ? (
                <ImageWithFallback
                  src={item.imagePath ? item.imagePath : placeholder}
                  alt="vehicle"
                  fallbackSrc={placeholder}
                 data-attribute="DriverDetail_Default_ImageWithFallback" />
              ) : (
                " "
              )}
            </div>
          ) : null}
          <div
            className={
              item?.orderType === CONSTANTS.MANAGED_EQUIPMENT
                ? "LeadrOrderSubTitle"
                : "LeadrNonSubtitle"
            }
          >
            <div
              className={
                item?.subOrderType == CONSTANTS.MANAGEMENT_VEHICLE
                  ? "itemId management"
                  : "itemId"
              }
            >
              <p className="label">Order Detail ID</p>
              <Tooltip content={itemIdVal()} data-attribute="DriverDetail_Default_Tooltip">
                <p>{itemIdVal()}</p>
              </Tooltip>
            </div>
            <div className="vehicle-Type">
              <Label data-attribute="DriverDetail_Default_Label">Request Type</Label>
              <Tooltip
                content={
                  item?.subOrderType == CONSTANTS.PRODUCTION_VEHICLE
                    ? item.subOrderType
                    : item?.orderType
                }
               data-attribute="DriverDetail_Default_Tooltip_2">
                <div className="content">
                  {item?.subOrderType == CONSTANTS.PRODUCTION_VEHICLE ||
                  item?.subOrderType == CONSTANTS.MANAGEMENT_VEHICLE
                    ? item.subOrderType
                    : item?.orderType}
                </div>
              </Tooltip>
            </div>
            <div className="frs-order-no">
              <Label data-attribute="DriverDetail_Default_Label_2">FRS Order #</Label>
              <Tooltip content={item?.frsOrderNumber + ""} data-attribute="DriverDetail_Default_Tooltip_3">
                <div>{item?.frsOrderNumber || "-"}</div>
              </Tooltip>
            </div>
            <div className="status icon">
              <Label data-attribute="DriverDetail_Default_Label_3">
                {" "}
                {props?.iconReturn(item?.itemStatus)}
                {props?.orderDetails?.orderStatus === "Approval In Process" &&
                item?.itemStatus === "Approved"
                  ? "Pending Approval"
                  : item?.itemStatus}
              </Label>
            </div>
          </div>
        </div>
      </>
    ),
    content: (
      <div
        className={`${
          item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT
            ? "nonstandardCard"
            : ""
        } ${props?.isBulkOrder ? "bulkorder" : ""}`}
      >
        <div
          className={`${props?.isBulkOrder ? "mt-lg-2 px-3" : "mt-lg-4 px-3 mt-sm-4"} ${
            item?.orderType === "Vehicle Request"
              ? "detailList"
              : "detailList managedEquipment"
          }`}
        >
          <div className="attachment-block-orderdetails">
            <AttachmentLink item={item} index={index} itemLevel={"Request"} />
          </div>
          {item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ? (
            <div className="vehicleType">
              <Label data-attribute="DriverDetail_Default_Label_4">Vehicle</Label>
              <Tooltip content={item.vehicleType} data-attribute="DriverDetail_Default_Tooltip_4">
                <div>{item.vehicleType || "-"}</div>
              </Tooltip>
            </div>
          ) : (
            ""
          )}
          {item?.orderType === CONSTANTS.MANAGED_EQUIPMENT ? (
            <>
              <div className="equipmentType">
                <Label data-attribute="DriverDetail_Default_Label_5">Equipment Type</Label>
                <Tooltip content={getEquipmentType()} data-attribute="DriverDetail_Default_Tooltip_5">
                  <div>{getEquipmentType()}</div>
                </Tooltip>
              </div>
            </>
          ) : null}
          {item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? (
            <div className="driver-title mb-sm-2 mb-2">
              <Label data-attribute="DriverDetail_Default_Label_6">Driver Title</Label>
              <Tooltip content={item.driverTitle} data-attribute="DriverDetail_Default_Tooltip_6">
                <div>{item.driverTitle || "-"}</div>
              </Tooltip>
            </div>
          ) : (
            <>
              {item?.requestSearchCriteria?.showVehicleCapacity ? (
                <div className="vehicleSize">
                  <Label data-attribute="DriverDetail_Default_Label_7">Vehicle Capacity</Label>
                  <Tooltip content={item.vehicleCapacity} data-attribute="DriverDetail_Default_Tooltip_7">
                    <div>{item.vehicleCapacity || "-"}</div>
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
            </>
          )}
          {item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? (
            <div className="driver-detail mb-sm-0 mb-2">
              {!props?.isBulkOrder && (
                <>
                  <Label data-attribute="DriverDetail_Default_Label_8">Driver Details</Label>
                  <div className="driver-details-itemLevel">
                    {item?.orderType == "Vehicle Request"
                      ? item?.vehicleDriverDetails?.map(
                          (x: any, index: any) => (
                            <div
                              className="blueBadge"
                              onClick={props?.onDriverClick}
                              key={index}
                            >
                              {x?.employeeName}
                            </div>
                          )
                        )
                      : ""}
                  </div>
                </>
              )}
            </div>
          ) : item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ? (
            <div
              className={
                item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE
                  ? item?.requestSearchCriteria?.showVehicleCapacity
                    ? "doors truck"
                    : "doors van"
                  : "doors management"
              }
            >
              <Label data-attribute="DriverDetail_Default_Label_9"># of Doors</Label>
              <Tooltip content={item.noOfDoors} data-attribute="DriverDetail_Default_Tooltip_8">
                <div>{item.noOfDoors || "-"}</div>
              </Tooltip>
            </div>
          ) : (
            ""
          )}
          {item?.orderType === "Non-Standard Equipment" ? (
            <NonStandardItemDetail item={item}  data-attribute="DriverDetail_Default_NonStandardItemDetail" />
          ) : (
            ""
          )}
          {item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE ? (
            <>
              <div
                className={`${
                  props?.isBulkOrder ? "mb-sm-2" : "mb-sm-4"
                } vehicle-management  mb-2`}
              >
                <Label data-attribute="DriverDetail_Default_Label_10">Vehicle</Label>
                <Tooltip content={item.vehicleType} data-attribute="DriverDetail_Default_Tooltip_9">
                  <div>{item.vehicleType || "-"}</div>
                </Tooltip>
              </div>
              <div className="driveTrain management">
                <Label data-attribute="DriverDetail_Default_Label_11">Drive Train</Label>
                <Tooltip content={item.driveTrain} data-attribute="DriverDetail_Default_Tooltip_10">
                  <div>{item.driveTrain || "-"}</div>
                </Tooltip>
              </div>
              <div className="driver-detail mb-sm-3 mb-2">
                <Label data-attribute="DriverDetail_Default_Label_12">Fuel Type</Label>
                <Tooltip content={item?.fuelType || "-"} data-attribute="DriverDetail_Default_Tooltip_11">
                  <div>{item?.fuelType || "-"}</div>
                </Tooltip>
              </div>
            </>
          ) : (
            ""
          )}
          {item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ? (
            <>
              <div className="upfit-option">
                <Label data-attribute="DriverDetail_Default_Label_13">Upfit Option</Label>
                <Tooltip content={item.upfitOption} data-attribute="DriverDetail_Default_Tooltip_12">
                  <div>{item.upfitOption || "-"}</div>
                </Tooltip>
              </div>
              <div className="driveTrain">
                <Label data-attribute="DriverDetail_Default_Label_14">Drive Train</Label>
                <Tooltip content={item.driveTrain} data-attribute="DriverDetail_Default_Tooltip_13">
                  <div>{item.driveTrain || "-"}</div>
                </Tooltip>
              </div>
              <div
                className={`upfit-option production ${
                  item?.requestSearchCriteria?.showVehicleCapacity ? "truck" : "van"
                }`}
              >
                <Label data-attribute="DriverDetail_Default_Label_15">Fuel Type</Label>
                <Tooltip content={item?.fuelType || "-"} data-attribute="DriverDetail_Default_Tooltip_14">
                  <div>{item?.fuelType || "-"}</div>
                </Tooltip>
              </div>
            </>
          ) : (
            ""
          )}
          {props?.isBulkOrder ? (
            <>
              <div
                className={`descriptionType ${
                  item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE
                    ? "management"
                    : item?.requestSearchCriteria?.showVehicleCapacity
                    ? "truck"
                    : "van managed"
                }`}
              >
                <Label data-attribute="DriverDetail_Default_Label_16">Description</Label>
                <Tooltip content={item?.description || "-"} data-attribute="DriverDetail_Default_Tooltip_15">
                  <div>{item?.description || "-"}</div>
                </Tooltip>
              </div>
              <div
                className={`makeType ${
                  item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE
                    ? "management"
                    : item?.requestSearchCriteria?.showVehicleCapacity
                    ? "truck"
                    : "van managed"
                }`}
              >
                <Label data-attribute="DriverDetail_Default_Label_17">Make</Label>
                <Tooltip content={item?.make || "-"} data-attribute="DriverDetail_Default_Tooltip_16">
                  <div>{item?.make || "-"}</div>
                </Tooltip>
              </div>
              {item?.orderType !== CONSTANTS.MANAGED_EQUIPMENT ? (
                <div
                  className={`modelType ${
                    item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE
                      ? "management"
                      : item?.requestSearchCriteria?.showVehicleCapacity
                      ? "truck"
                      : "van"
                  }`}
                >
                  <Label data-attribute="DriverDetail_Default_Label_18">Model</Label>
                  <Tooltip content={item?.model || "-"} data-attribute="DriverDetail_Default_Tooltip_17">
                    <div>{item?.model || "-"}</div>
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
            </>
          ) : null}
          {item?.orderType === CONSTANTS.NON_STANDARD_EQUIPMENT ? (
            <div className="price mb-sm-3 mb-4">
              <Label data-attribute="DriverDetail_Default_Label_19">Price</Label>
              <Tooltip
                content={
                  "$" + props.getFormattedValue(Number(item.pricePerUnit || 0))
                }
               data-attribute="DriverDetail_Default_Tooltip_18">
                <div>
                  {"$" +
                    props.getFormattedValue(Number(item.pricePerUnit || 0)) ||
                    "-"}
                </div>
              </Tooltip>
            </div>
          ) : (
            <div
              className={`price mb-sm-3 ${
                item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE
                  ? "management"
                  : item?.requestSearchCriteria?.showVehicleCapacity
                  ? "truck"
                  : "van"
              }`}
            >
              <Label data-attribute="DriverDetail_Default_Label_20">Price</Label>
              <Tooltip
                content={"$" + props.getFormattedValue(Number(item.price || 0))}
               data-attribute="DriverDetail_Default_Tooltip_19">
                <div>
                  {"$" + props.getFormattedValue(Number(item.price || 0)) ||
                    "-"}
                </div>
              </Tooltip>
            </div>
          )}
          {item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE && (
            <>
              <div className="snow-setup-container mb-sm-3 mb-4">
                <Label data-attribute="DriverDetail_Default_Label_21">Snow Setup</Label>
                <Tooltip content={item.snowSetup} data-attribute="DriverDetail_Default_Tooltip_20">
                  <div>{item.snowSetup || "-"}</div>
                </Tooltip>
              </div>
            </>
          )}
        </div>

        {item?.catalogOverrideInfo && (
          <div className="catalog-override-section px-3 mb-1">
            <div className="catalog-override-content">
              <Row>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} className="mb-1">
                  <div className="catalog-override-red" data-attribute="DriverDetail_Default_Static_Override_1">
                    Catalog Override: {item?.catalogOverrideDate
                      ? Moment(item?.catalogOverrideDate).format('M/D/YYYY')
                      : '-'}
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-1">
                  <div className="catalog-override-red" data-attribute="DriverDetail_Default_Static_Override_2">
                    Override Reason: {item?.catalogOverrideReason ?? '-'}
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} className="mb-2">
                  <div className="catalog-override-red" data-attribute="DriverDetail_Default_Static_Override_3">
                    {(() => {
                      const parentReq = props?.orderDetails?.requests?.find(
                        (r: any) => r.requestId === item?.originalOrderRequestDetailId
                      );
                      const displayId = parentReq
                        ? `${parentReq.orderId} - ${parentReq.itemNumber}`
                        : (item?.originalOrderRequestDetailId ?? '-');
                      return `Original Detail ID: ${displayId}`;
                    })()}
                  </div>
                </Col>
              </Row>

              <div className="original-selections-title">
                <div className="catalog-override-red" data-attribute="DriverDetail_Default_Static_Override_4">Original Selections:</div>
              </div>

              {item?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE && (
                <>
                  <Row>
                    <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_29">Vehicle</Label>
                      <div>{item?.catalogOverrideInfo?.vehicleType || '-'}</div>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_30">Vehicle Capacity</Label>
                      <div>{item?.catalogOverrideInfo?.vehicleCapacity || '-'}</div>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={2} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_31"># of Doors</Label>
                      <div>{item?.catalogOverrideInfo?.noOfDoors || '-'}</div>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={2} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_32">Upfit Option</Label>
                      <div>{item?.catalogOverrideInfo?.upfitOption || '-'}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_33">Drive Train</Label>
                      <div>{item?.catalogOverrideInfo?.driveTrain || '-'}</div>
                    </Col>
                    <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_34">Fuel Type</Label>
                      <div>{item?.catalogOverrideInfo?.fuelType || '-'}</div>
                    </Col>
                    <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                      <Label data-attribute="DriverDetail_Default_Label_36">Snow Setup</Label>
                      <div>{item?.catalogOverrideInfo?.snowSetup || '-'}</div>
                    </Col>
                  </Row>
                </>
              )}

              {item?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE && (
                <Row>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_37">Driver Title</Label>
                    <div>{item?.catalogOverrideInfo?.originalDriverTitle|| '-'}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_38">Vehicle</Label>
                    <div>{item?.catalogOverrideInfo?.vehicleType || '-'}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_39"># of Doors</Label>
                    <div>{item?.catalogOverrideInfo?.noOfDoors || '-'}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_40">Drive Train</Label>
                    <div>{item?.catalogOverrideInfo?.driveTrain || '-'}</div>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_41">Fuel Type</Label>
                    <div>{item?.catalogOverrideInfo?.fuelType || '-'}</div>
                  </Col>
                </Row>
              )}

              {item?.orderType === CONSTANTS.MANAGED_EQUIPMENT && (
                <Row>
                  <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                    <Label data-attribute="DriverDetail_Default_Label_42">Equipment Type</Label>
                    <div>{item?.catalogOverrideInfo?.equipmentType || '-'}</div>
                  </Col>
                </Row>
              )}
              <Row>
                <Col xs={12} sm={6} md={3} lg={3} xl={3} className="mb-2">
                  <Label data-attribute="DriverDetail_Default_Label_43">Price</Label>
                  <div>
                    {(() => {
                      const originalUnitPrice = item?.catalogOverrideInfo?.orignalUnitPrice
                        ?? '0.00';
                      const numericPrice = Number(originalUnitPrice);
                      return Number.isFinite(numericPrice)
                        ? `$${props.getFormattedValue(numericPrice)}`
                        : '-';
                    })()}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}

        {!props?.isBulkOrder && (
          <RequestReasonDetail
            planned={props?.planned?.[index]}
            growth={props?.growth?.[index]}
            unplanned={props?.unplanned?.[index]}
            editPlanned={props.ShowPlannedPopup}
            editUnPlanned={props.ShowUnPlannedPopup}
            editGrowth={props.ShowGrowthPopup}
            showEditIcon={props.showEditIcon}
            viewType="OrderDetail-screen"
          />
        )}

        <div className="clearfix"></div>
        <Row className="approver-comments px-3">
          <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-sm-2 mb-3">
            <Label className="blueLabel" data-attribute="DriverDetail_Default_Label_22">Approver Comments</Label>
            {!actionCommentValue?.length &&
              props?.orderDetails?.approvalHistory?.map(
                (approvalHistoryItem: any, _index: any) => {
                  const attemptNo = approvalHistoryItem?.attemptNo;
                  const approvalList = approvalHistoryItem?.approvalList;
                  let overrideInserted = false;
                  const filteredList =  approvalList.filter((item :any)=> {
                    if (!(props?.orderDetails?.isApprovalOverride) && item?.approvalHistoryComments?.length) return true;
                    if (props?.orderDetails?.isApprovalOverride) {
                      if(!overrideInserted && item.isApprovalOverride && item?.approvalHistoryComments?.length){
                        overrideInserted = true;
                        return true;
                      }
                      if(!item.isApprovalOverride && item?.approvalHistoryComments?.length){
                        return true;
                      }
                      return false;
                    }
                  });
                  actionCommentValue.push({
                    attemptNo: attemptNo,
                    list: filteredList,
                  });
                }
              )}
            {actionCommentValue?.map((reqVal: any) => {
              return (
                <div key={reqVal?.attemptNo}>
                  {actionCommentValue?.length > 1 && <Label className="blueLabel" data-attribute="DriverDetail_Default_Label_23">Attempt {reqVal?.attemptNo}</Label>}
                  {reqVal?.list?.length ?
                    reqVal?.list?.map((step: any) => {
                    if(step?.approvalHistoryComments?.length){
                    return step?.approvalHistoryComments?.map(
                      (valueItem: any, index: any) => {
                        if (valueItem?.comments?.length){
                          userActionComment.push(valueItem);
                          return (
                            <div className="mb-2" key={index}>
                              <span className="Approver-date">
                                {Moment(valueItem?.approvedDate).format(
                                  "MM/DD/YYYY"
                                )}
                              </span>
                              <span className="Approver-name">
                                <b>{valueItem?.approverName}</b>
                              </span>
                              <p className="Approver-comment">
                                {valueItem?.comments}
                              </p>
                            </div>
                          );
                        }
                      }
                    );
                  }
                  }) : actionCommentValue?.length > 1 && <div>-</div>
                  }
                </div>
              );
            })}
            {userActionComment?.length == 0 && actionCommentValue?.length == 1 ? <div>-</div> : null}
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-sm-2 mb-3">
            {props?.orderDetails?.orderStatus ==
              CONSTANTS.ORDER_STATUS.CANCELLED ||
            props?.orderDetails?.orderStatus ==
              CONSTANTS.ORDER_STATUS.REJECTED ||
            props?.orderDetails?.orderStatus ==
              CONSTANTS.ORDER_STATUS.DELETED ? (
              <>
                <Label className="blueLabel" data-attribute="DriverDetail_Default_Label_24">Cancelled Comments</Label>
                {props?.orderDetails?.cancelComments ? (
                  <div className="mb-2" key={index}>
                    <span className="Approver-date">
                      {Moment(props?.orderDetails?.updatedDate).format(
                        "MM/DD/YYYY"
                      )}
                    </span>
                    <span className="Approver-name">
                      <b>{props?.orderDetails?.modifiedBy}</b>
                    </span>
                    <p className="Approver-comment mt-1">
                      {props?.orderDetails?.cancelComments ?? "-"}
                    </p>
                  </div>
                ) : (
                  "-"
                )}
              </>
            ) : null}
          </Col>
        </Row>
      </div>
    ),
    uuid: `Accordion${index}`,
  });
  });

  return (
      <div className={`Driver-detail mt-3 mb-3 mb-lg-0`}>
          <Card data-attribute="DriverDetail_Default_Card">
              <Accordion
                  Items={ExpandedItems}
                  preExpanded={["Accordion0"]}
                  allowZeroExpanded
                  onChange={props.onChange}
                  className="custom-accordion"
               data-attribute="DriverDetail_Default_Accordion" />
          </Card>
      </div>
  );
};

export default DriverDetail;
